import { render, staticRenderFns } from "./SfSearchBar.vue?vue&type=template&id=0bc59726&"
import script from "./SfSearchBar.vue?vue&type=script&lang=js&"
export * from "./SfSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./SfSearchBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports